import { Avatar } from "native-base";

export default Avatar;